import api from 'services/api'

const setLock = (objectId, objectType) =>
  api.post(`/lock`, {id: objectId, object: objectType})

const extendLock = (lockId, objectId, objectType) =>
  api.post(`/lock/${lockId}`, {id: objectId, object: objectType})

export const releaseLock = (lockId) =>
  api.delete(`/lock/${lockId}`)

export const setOrderLock = (orderId) =>
  setLock(orderId, "ORDER")

export const setContractorLock = (orderId) =>
  setLock(orderId, "CONTRACTOR")


export const extendOrderLock = (orderId, lockId) =>
  extendLock(lockId, orderId,"ORDER")

export const extendContractorLock = (contractorId, lockId) =>
  extendLock(lockId, contractorId,"CONTRACTOR")
